module.exports = __webpack_public_path__ + "img/poster-1.563a224d.jpg";